export const serviceHelper = {
  authHeader,
  isAvailable,
  getEndpoint,
  getEndpointOData,
  getProjectEndpoint,
  getProjectEndpointOData,
  getProjectScope,
  resourceHeader,
  uploadHeader,
  syncHeader,
  deleteConfig,
  getBaseURL,
  getToken,
  getCurrentProjectId,
  setCurrentProjectId,
  clearCurrentProjectId,
  getClientId,
};

const OPENED_PROJECT_KEY = "openedProjectId";

function getClientId() {
  return "Visoplan Plugin Archicad";
}

function getToken() {
  return JSON.parse(localStorage.getItem("token"));
}

function getCurrentProjectId() {
  return localStorage.getItem(OPENED_PROJECT_KEY) || undefined;
}

function setCurrentProjectId(projectId) {
  if (projectId) {
    localStorage.setItem(OPENED_PROJECT_KEY, projectId);
  } else {
    localStorage.removeItem(OPENED_PROJECT_KEY);
  }
}

function clearCurrentProjectId() {
  localStorage.removeItem(OPENED_PROJECT_KEY);
}

function getProjectScope() {
  const id = getCurrentProjectId();
  return id ? `project/${id}/` : "";
}

function authHeader() {
  let token = getToken();
  if (token && token.bearer) {
    const contentLanguage = window.isGerman ? "de-DE" : "en-US";
    return {
      headers: {
        Authorization: `bearer ${token.bearer}`,
        "Content-Language": contentLanguage,
      },
    };
  } else {
    return {};
  }
}

function isAvailable() {
  let token = getToken();
  if (token && token.expires && token.remember) {
    if (token.remember === true) {
      const expireTime = Date.parse(token.expires);
      return Date.now() < expireTime;
    }
  }

  return false;
}

function getEndpoint(baseUrl, ids) {
  let endPoint = ids
    .map((id) => {
      return id;
    })
    .join(",");

  endPoint = `${getBaseURL()}${baseUrl}/${endPoint}`;
  return endPoint;
}

function getEndpointOData(baseUrl, ids) {
  let query = ids
    .map((id) => {
      return `'${id}'`;
    })
    .join(", ");
  query = ids && ids.length ? `?$filter=id in (${query})` : '';
  return `${getBaseURL()}${baseUrl}${query}`;
}

function getProjectEndpoint(baseUrl, ids) {
  let endPoint = ids
    .map((id) => {
      return id;
    })
    .join(",");

  endPoint = `${getBaseURL()}${getProjectScope()}${baseUrl}/${endPoint}`;
  return endPoint;
}

function getProjectEndpointOData(baseUrl, ids) {
  let query = ids
    .map((id) => {
      return `'${id}'`;
    })
    .join(", ");
  query = ids && ids.length ? `?$filter=id in (${query})` : '';
  return `${getBaseURL()}${getProjectScope()}${baseUrl}${query}`;
}

function resourceHeader() {
  let token = getToken();
  if (token && token.bearer) {
    return {
      headers: {
        Accept: "application/octet-stream",
        Authorization: `bearer ${token.bearer}`,
      },
      responseType: "arraybuffer",
    };
  } else {
    return {};
  }
}

function uploadHeader() {
  let token = getToken();
  if (token && token.bearer) {
    return {
      headers: {
        Authorization: `bearer ${token.bearer}`,
        ContentType: "multipart/form-data",
      },
    };
  } else {
    return {};
  }
}

function syncHeader() {
  let token = getToken();
  if (token && token.bearer) {
    return {
      headers: { Authorization: `bearer ${token.bearer}` },
      responseType: "stream",
    };
  } else {
    return {};
  }
}

function deleteConfig(ids) {
  let token = getToken();
  if (token && token.bearer) {
    return {
      headers: { Authorization: `bearer ${token.bearer}` },
      data: ids,
    };
  } else {
    return {};
  }
}

function getBaseURL() {
  return window.baseURL === undefined
    ? "https://api.visoplan.de/api/"
    : window.baseURL;
}
